<template>
    <div id="discountPopup" class="vue-pop-up-modal">
        <div class="modal-header d-flex justify-content-between align-items-start">
            <h2 class="title virtual-p font-weight-bold mb-0">
                {{ title }}
            </h2>

            <button class="close-button mt-1" @click="handleClose">
                {{ translations.closeText }}
            </button>
        </div>

        <div class="modal-body">
            <div class="modal-description">
                <label for="input-discountcode">Kortingscode</label>
                <input type="text" class="form-control" id="input-discountcode" name="input-discountcode"
                       v-model="discountCode" @input="handleDiscountCode(); error = false;">
                <div v-if="error" class="error" for="input-discountcode">Kortingscode is ongeldig of onbekend.</div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" :class="{active: hasDiscount}" @click="checkDiscountValid" class="btn-primary">
                {{ translations.closeTextDiscountPopup }}
            </button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import translations from "../../mixins/translations";
import {nl} from "vuejs-datepicker/dist/locale";
import lodash, {isNumber} from "lodash";

export default {
    name: "DiscountPopup",

    mixins: [translations],

    props: {
        title: {
            type: String
        },
    },

    data() {
        return {
            nl: nl,
            discountCode: '',
            error: false,
        }
    },

    computed: {
        ...mapGetters([
            'getPopUpSettings',
            'getActiveDiscount',
            'getActiveDiscountCode',
            'hasDiscount'
        ]),

        hasButton() {
            return !lodash.isNil(this.getPopUpSettings.url) && !lodash.isNil(this.getPopUpSettings.url_text)
        },
    },

    created() {
        if (this.getActiveDiscountCode) {
            this.discountCode = this.getActiveDiscountCode;
        }
    },

    methods: {
        isNumber,
        ...mapActions([
            'updateDiscountCode',
            'setDiscountCode'
        ]),

        checkDiscountValid() {
            if (this.hasDiscount && this.getActiveDiscountCode !== '') {
                this.$toaster.success('Kortingscode is toegepast.');
                this.$modal.close();
                return;
            }

            if (this.discountCode === '') {
                this.updateDiscountCode();
                this.$modal.close();
                return;
            }

            this.error = true;
        },

        handleDiscountCode: lodash.debounce(function () {
            this.setDiscountCode(this.discountCode)
            this.updateDiscountCode();
        }, 250),

        handleClose() {
            this.$modal.close()
        }
    }
}
</script>
